// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1ho3y","content":"styles_content__Xd_YN","checkbox":"styles_checkbox__2rQff","checkboxLabel":"styles_checkboxLabel__xifR7"};